module.exports = __webpack_public_path__ + "static/media/bg9.e535f10c.jpeg";